import FIELD_TYPE from 'Component/Field/Field.config';
import {
    customerEmailAndPasswordFields
} from 'SourceComponent/MyAccountCustomerForm/MyAccountCustomerForm.form';
import {
    COMPANY_MAX_LENGTH,
    FIRSTNAME_MAX_LENGTH,
    LASTNAME_MAX_LENGTH
} from 'Util/Customer';
import { VALIDATION_INPUT_TYPE } from 'Util/Validator/Config';

export {
    customerEmailAndPasswordFields
};

/**
 * Override: add validation types on first name and last name
 * @param props
 * @returns {[{addRequiredTag: boolean, validateOn: string[], validationRule: {isRequired: boolean}, label: *, type: string, attr: {defaultValue, name: string, placeholder: *}}, {addRequiredTag: boolean, validateOn: string[], validationRule: {isRequired: boolean}, label: *, type: string, attr: {defaultValue, name: string, placeholder: *}}, ...[{addRequiredTag: boolean, validateOn: string[], validationRule: {isRequired: boolean}, label: *, type: string, attr: {defaultValue, name: string, placeholder: *}}]|*[]]}
 * @namespace PeggysagePwa/Component/MyAccountCustomerForm/Form/customerInformationFields */
export const customerInformationFields = (props) => {
    const {
        firstname,
        lastname,
        taxvat,
        showTaxVatNumber,
        handleChangeEmailCheckbox,
        handleChangePasswordCheckbox,
        showEmailChangeField,
        showPasswordChangeField,
        vatNumberRequired
    } = props;

    return [
        {
            type: FIELD_TYPE.text,
            label: __('First Name'),
            attr: {
                name: 'firstname',
                defaultValue: firstname,
                placeholder: __('Your first name')
            },
            addRequiredTag: true,
            validateOn: ['onChange'],
            validationRule: {
                inputType: VALIDATION_INPUT_TYPE.alphaSpaceDash,
                isRequired: true,
                match: (value) => value.length <= FIRSTNAME_MAX_LENGTH,
                customErrorMessages: {
                    onMatchFail: __('La longueur du champ prénom ne peut pas dépasser %s caractères.', FIRSTNAME_MAX_LENGTH)
                }
            }
        },
        {
            type: FIELD_TYPE.text,
            label: __('Last Name'),
            attr: {
                name: 'lastname',
                defaultValue: lastname,
                placeholder: __('Your last name')
            },
            addRequiredTag: true,
            validateOn: ['onChange'],
            validationRule: {
                inputType: VALIDATION_INPUT_TYPE.alphaSpaceDash,
                isRequired: true,
                match: (value) => value.length <= LASTNAME_MAX_LENGTH,
                customErrorMessages: {
                    onMatchFail: __('La longueur du champ nom ne peut pas dépasser %s caractères.', LASTNAME_MAX_LENGTH)
                }
            }
        },
        ...(showTaxVatNumber ? [
            {
                type: FIELD_TYPE.text,
                label: __('Tax/VAT Number'),
                attr: {
                    name: 'taxvat',
                    defaultValue: taxvat,
                    placeholder: __('Your tax/VAT number')
                },
                addRequiredTag: vatNumberRequired,
                validateOn: ['onChange'],
                validationRule: {
                    isRequired: vatNumberRequired
                }
            }
        ] : []),
        {
            type: FIELD_TYPE.checkbox,
            attr: {
                name: 'showEmailChangeField',
                defaultChecked: showEmailChangeField
            },
            events: {
                onChange: handleChangeEmailCheckbox
            },
            label: __('Change Email')
        },
        {
            type: FIELD_TYPE.checkbox,
            attr: {
                name: 'showPasswordChangeField',
                defaultChecked: showPasswordChangeField
            },
            events: {
                onChange: handleChangePasswordCheckbox
            },
            label: __('Change Password')
        }
    ];
};

/**
 * @param props
 * @returns {[{addRequiredTag: boolean, validateOn: [string], validationRule: {isRequired: boolean}, disabled: boolean, label: *, type: string, attr: {defaultValue, name: string, placeholder: *}}]}
 * @namespace PeggysagePwa/Component/MyAccountCustomerForm/Form/customerCompanyFields
 */
export const customerCompanyFields = (props) => {
    const { societe } = props;

    return [
        {
            type: FIELD_TYPE.text,
            label: __('Company name'),
            attr: {
                name: 'societe',
                defaultValue: societe,
                placeholder: __('Company name'),
                disabled: true
            },
            addRequiredTag: true,
            validationRule: {
                match: (value) => value.length <= COMPANY_MAX_LENGTH,
                customErrorMessages: {
                    onMatchFail: __('La longueur du nom de la société ne peut pas dépasser %s caractères.', COMPANY_MAX_LENGTH)
                }
            }
        }
    ];
};
